import { render, staticRenderFns } from "./panel.vue?vue&type=template&id=1bf9752c&scoped=true&"
import script from "./panel.vue?vue&type=script&lang=js&"
export * from "./panel.vue?vue&type=script&lang=js&"
import style0 from "./panel.vue?vue&type=style&index=0&id=1bf9752c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf9752c",
  null
  
)

export default component.exports